// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"f6afcf08","341":"dcbbde0f","453":"51cfd183","900":"0d584da3"}[chunkId] + ".chunk.js";
};